import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Button } from 'antd'
import PoliciesTable from '@pages/PoliciesTable'
import { policies } from '@services/api'

@inject((store: any) => {
    const { popupStore } = store
    return { popupStore }
})
@observer
export default class PoliciesTablePopup extends Component<any, any> {
    closePopup = () => {
        this.props.popupStore.togglePopup(false)
    }

    addSetToPol = async record => {
        const { popupStore, onSuccses } = this.props
        await policies.comparePolicies({ mainPol: +window.location.pathname.split('/')[3], comparedPol: record.id })
        onSuccses(record)
        popupStore.togglePopup(false)
    }

    render() {
        const {
            popupStore: { popupType },
            right_param_set_id
        } = this.props

        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                <div style={{ float: 'left', display: 'inline-block' }}>
                    <Button onClick={this.closePopup}>סגור</Button>
                </div>
            </div>
        )
        return (
            <Modal
                title={'טבלת פוליסות'}
                visible={popupType === 'policiesTable'}
                footer={footerButtons}
                onCancel={this.closePopup}
                width={1600}
            >
                <PoliciesTable propCallback={this.addSetToPol} right_param_set_id={right_param_set_id} />
            </Modal>
        )
    }
}
